import React from 'react'
import Responsive from 'react-responsive'

export const IPhone = props => <Responsive {...props} maxWidth={320} />
export const Mobile = props => <Responsive {...props} maxWidth={605} />
export const Smartphone = props => <Responsive {...props} maxWidth={767} />
export const SmartphoneNot = props => <Responsive {...props} minWidth={768} />
export const Tablet = props => (
  <Responsive {...props} minWidth={768} maxWidth={1365} />
)
export const IPad = props => (
  <Responsive {...props} minWidth={1024} maxWidth={1365} />
)
export const DesktopPlusNot = props => <Responsive {...props} maxWidth={1365} />
export const DesktopPlus = props => <Responsive {...props} minWidth={1366} />
export const DesktopNot = props => <Responsive {...props} maxWidth={1023} />
export const Desktop = props => <Responsive {...props} minWidth={1024} />
export const FullHD = props => <Responsive {...props} minWidth={1920} />
